import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { TemplatesTable } from "./components/TemplatesTable";
import { CreateTemplateModal } from "./components/CreateTemplateModal/CreateTemplateModal";
import { useTemplatesTab } from "./useTemplatesTab";

export const TemplatesTab: React.FC = () => {
  const {
    templates,
    templatesLoading,
    error,
    createModalOpen,
    openCreateModal,
    closeCreateModal,
  } = useTemplatesTab();

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box
        data-testid="templates-header"
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}
      >
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Templates
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Create and manage PDF templates with placeholders
          </Typography>
        </Box>
        <Button
          data-testid="create-template-btn"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={openCreateModal}
        >
          Create Template
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Paper>
        <Box data-testid="templates-list">
          {templatesLoading && templates.length === 0 ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress />
            </Box>
          ) : templates.length === 0 ? (
            <Box data-testid="empty-state" sx={{ p: 4, textAlign: "center" }}>
              <Typography color="text.secondary">
                No templates yet. Create your first template to get started.
              </Typography>
            </Box>
          ) : (
            <TemplatesTable templates={templates} />
          )}
        </Box>
      </Paper>

      {/* Create Template Modal */}
      <CreateTemplateModal
        open={createModalOpen}
        onClose={closeCreateModal}
      />
    </Box>
  );
};
